<template>
  <el-dialog
    ::title="$t('CMSProduct.addOrigin')"
    :append-to-body="true"
    :visible.sync="visible"
    :close-on-click-modal="false">
    <el-form :model="model">
      <el-form-item :label="$t('CMSProduct.country')">
        <el-select v-model="model.country" :placeholder="$t('CMSProduct.selectCountry')" filterable value-key="id" @change="v=>handleCountryChange(v)">
         <el-option
           v-for="item in countries"
           :key="item.id"
           :label="item.name"
           :value="item">
         </el-option>
       </el-select>
      </el-form-item>
      <el-form-item :label="$t('CMSProduct.region')">
        <el-select :disabled="model.country==null" v-model="model.region" :placeholder="$t('CMSProduct.selectRegion')" filterable value-key="id" @change="v=>handleRegionChange(v)">
         <el-option
           v-for="item in regions"
           :key="item.id"
           :label="item.name[lang]"
           :value="item">
           <span v-if="item.id==null" style="text-align: center"><strong><i class="el-icon-circle-plus"></i> {{ item.name[lang] }}</strong></span>
         </el-option>

       </el-select>
      </el-form-item>
      <el-form-item v-if="newRegion" v-for="l in cms_languages" :key="l.id" :label="$t('CMSProduct.regionName', { regionName: l.name})">
          <el-input v-model="model.newRegionName[l.code]"></el-input>
      </el-form-item>
      <el-form-item :label="$t('CMSProduct.city')">
        <el-select :disabled="model.region==null" v-model="model.city" :placeholder="$t('CMSProduct.selectCity')" filterable value-key="id" @change="v=>handleCityChange(v)">
         <el-option
           v-for="item in cities"
           :key="item.id"
           :label="item.name[lang]"
           :value="item">
           <span v-if="item.id==null" style="text-align: center"><strong><i class="el-icon-circle-plus"></i> {{ item.name[lang] }}</strong></span>
         </el-option>
       </el-select>
      </el-form-item>
      <el-form-item v-if="newCity" v-for="l in cms_languages" :key="l.id" :label="$t('CMSProduct.cityName', { cityName: l.name})">
          <el-input v-model="model.newCityName[l.code]"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.Cancel')}}</el-button>
      <el-button type="primary" @click="addNewOrigin">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Origins-dialog',
	props: {
		visible : {type : Boolean},
    // 'append-to-body' : {
    //   type: Boolean,
    //   default : false,
    // },
	},
  data() {
    return {
      newRegion :false,
      newCity: false,
      model : {
        country : null,
        region : null,
        city : null,
        newRegionName : {fr : null, en : null},
        newCityName : {fr : null, en : null},
      },
      regions : [],
      cities: [],
      addRegionOption : {
        name : {
          fr : "Ajouter une nouvelle région",
          en : "Add a new region"
        }
      },
      addCityOption : {
        name : {
          fr : "Ajouter une nouvelle ville",
          en : "Add a new city"
        }
      },
    };
  },components: {

  },
	methods: {
    handleCountryChange(country){
      this.fetchRegions(country.id)
    },
    handleRegionChange(option, index){
      if(option.id==null){
        this.newRegion = true;
      }else{
        this.newRegion = false;
        this.fetchCities(option.id);
      }
    },
    handleCityChange(option, index){
      if(option.id==null){
        this.newCity = true;
      }else{
        this.newCity = false;
      }
    },
    fetchRegions(countryId){
      return cmsAPI.fetchRegions({countryId})
        .then(regions=>{
          this.regions.splice(0);
          this.regions.push(this.addRegionOption)
          this.regions.push(...regions)
        })
    },
    fetchCities(regionId){
      return cmsAPI.fetchCities({regionId})
        .then(cities=>{
          this.cities.splice(0);
          this.cities.push(this.addCityOption)
          this.cities.push(...cities)
        })
    },
    resetFields(){
      this.newRegion = false;
      this.newCity = false;
      this.model.region = null;
      this.model.city = null;
      this.regions.splice(0);
      this.cities.splice(0);
      this.model.country = null;
    },
    addNewRegion(country, name){
      if(this.newRegion) {
        return cmsAPI.saveRegion({name, country})
          .then((region)=>cmsAPI.getRegion(region.id))
      }
      return Promise.resolve(this.model.region);
    },
    addNewCity(region, name){
      if(this.newCity) {
        return cmsAPI.saveCity({name, region})
          .then((city)=>cmsAPI.getCity(city.id))
      }
      return Promise.resolve(this.model.city)
    },
    addNewOrigin(){
      let param = {country : this.model.country};
      return this.addNewRegion(this.model.country, this.model.newRegionName)
        .then((region) => {
          if (region != null) {
            param.region = {id:region.id, name:region.name[this.lang]};
          }
          return this.addNewCity(region, this.model.newCityName)
        }).then((city) => {
          if (city != null) {
            param.city = {id:city.id, name:city.name[this.lang]};
          }

          this.$emit('add',param)
          this.close();
        })
    },
    close(){
      this.$emit('close');
      this.resetFields();
    },
    ...mapActions('controlData',['fetchCountries'])
	},
	computed: {
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    ...mapState('controlData',['languages', 'countries']),
	},
  created(){
    this.fetchCountries()
  }
}
</script>
<style>
</style>
